export const UPDATE_ALL_USERS = 'UPDATE_ALL_USERS'
export const UPDATE_USERS = 'UPDATE_USERS'
export const UPDATE_USER_PAGINATION = 'UPDATE_USER_PAGINATION'
export const UPDATE_USER_TYPES = 'UPDATE_USER_TYPES'
